/* eslint-disable no-unused-vars */
import { NextSeo } from 'next-seo';
import { useFetch } from 'services/useFetch';
import { IS_NO_ROBOT_INDEX } from 'src/constants';
import { IMAGE_DEFAULT, WEB_KEYWORD, WEB_NAME } from 'src/constants/layout';
import { getFeatureImage } from 'src/utils/contents';

const PageVideo = ({
  articles,
  meta
}) => {
  return (
    <>
    <NextSeo
    noindex={IS_NO_ROBOT_INDEX}
    nofollow={IS_NO_ROBOT_INDEX}
    title={meta?.title}
    description={meta?.description}
    openGraph={{
      type: 'article',
      locale: 'th_TH',
      site_name: WEB_NAME,
      title: meta?.title,
      description: meta?.description,
      // url: baseUrlCategory,
      images: [
        {
          url: IMAGE_DEFAULT,
          width: '1920',
          height: '1080',
          alt: WEB_NAME
        }
      ]
    }}
    additionalMetaTags={[
      {
        name: 'keywords',
        content: meta?.keyword || WEB_KEYWORD
      }
    ]} />
    {!articles
      ? <div className='video-iframe'>
          {getFeatureImage(articles)}
        </div>
      : <div className='no-video'>ไม่มี VDO หรือ VDO นี้ถูกลบไปแล้ว</div>}
    </>
  );
};
export async function getServerSideProps ({ req, res, query }) {
  const initProps = {
    statusCode: 200,
    errMessage: null,
    articles: null,
    meta: null
  };

  try {
    const { data } = await useFetch(`/api/v1.0/video/contents/${query?.id}`);
    if (data) {
      initProps.articles = data.data;
      initProps.meta = data.meta;
    }
  } catch (err) {
    console.log('==========> CATEGORY ERROR', err.message);
    initProps.errMessage = err.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return {
    props: initProps
  };
}
export default PageVideo;
